import { createAction } from '@reduxjs/toolkit';



export const getonboardingmerchantsInfoRequest = createAction('GET_ONBOARDING_MERCHANTSINFO', ( data) => {
    return{
        payload: {
			data
        }
    }
});

export const getonboardingmerchantsInfoSuccess = createAction('GET_ONBOARDING_MERCHANTSINFO_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getonboardingmerchantsInfoFailure = createAction('GET_ONBOARDING_MERCHANTSINFO_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});
